import z from "zod"

import { DragDropBaseSchema } from "./DragDropBase"

export const DragSourceSchema = DragDropBaseSchema.extend({
  dragSourceID: z.string().optional(),
  label: z.string().optional()
})

interface DragSourceBase<Data> extends z.infer<typeof DragSourceSchema> {
  data: Data
}

export type DragSource<Data = unknown, Meta = unknown> = unknown extends Meta
  ? DragSourceBase<Data> & { meta?: Meta }
  : DragSourceBase<Data> & { meta: Meta }

export function isDragSource(value: unknown): value is DragSource

export function isDragSource<
  DataSchema extends z.ZodTypeAny | unknown = unknown,
  MetaSchema extends z.ZodTypeAny | unknown = unknown
>(
  value: unknown,
  options?: { dataSchema?: DataSchema; metaSchema?: MetaSchema }
): value is DragSource<
  DataSchema extends z.ZodTypeAny ? z.infer<DataSchema> : unknown,
  MetaSchema extends z.ZodTypeAny ? z.infer<MetaSchema> : unknown
>

export function isDragSource(
  value: unknown,
  options?: { dataSchema?: z.ZodType; metaSchema?: z.ZodType }
): value is DragSource {
  const { dataSchema, metaSchema } = options || {}

  const schema = DragSourceSchema.extend({
    data: dataSchema || z.any(),
    meta: metaSchema || z.any()
  })

  return schema.safeParse(value).success
}
